var map = {
	"./blog.yml": 50,
	"./cloud.yml": 51,
	"./color.yml": 52,
	"./country.yml": 53,
	"./dio.yml": 54,
	"./doc.yml": 55,
	"./emoji.yml": 56,
	"./git.yml": 57,
	"./icon.yml": 58,
	"./license.yml": 59,
	"./link.yml": 60,
	"./metrics.yml": 61,
	"./people.yml": 62,
	"./soft.yml": 63,
	"./src.yml": 64,
	"./status.yml": 65
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;